import {mapActions, mapState} from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { clearRegisterLandingUrl } from '@/helpers/registerLanding';

export default {
  computed: {
    ...mapState({
      size: state => state.admin.companies.size,
      form: state => state.admin.companies.form,
      businesses: state => state.admin.companies.business,
      formErrors: rootState => rootState.errors,
      btnLoading: rootState => rootState.btnLoading,
      provinces: state => state.particles.province.list,
      settings: rootState => rootState.settings
    })
  },
  created() {
    if (this.isApplicationRegister ) {
      this.formData.company.form = null;
    }
  },
  async beforeMount() {
    this.$store.commit('setErrors', []);
    if (this.isApplicationRegister) {
      if (typeof this.$route.query.rf === 'string') {
        sessionStorage.setItem('rf', this.$route.query.rf);
      }
      this.formData.register_media = sessionStorage.getItem('rf');
    }
  },
  data: () => ({
    multiselect: {
      businesses: []
    },
    formData: {
      email: '',
      first_name: '',
      last_name: '',
      company: {
        name: '',
        name_kana: '',
        form: 1,
        size: 1,
        business: [],
        is_special_cases_during_withholding_period: false,
        is_staff: true,
        province_id: null,
        address: null,
        settlement_month: null,
        health_insurance: null,
        pension_insurance: [],
        longterm_care_insurance: null,
        employment_insurance: [],
        labor_accident_insurance: null,
        phone: null
      },
      verify: true
    },
    ssoRegister: false
  }),
  methods: {
    ...mapActions({
      logout: 'frontend/auth/logout'
    }),
    async handleRegister() {
      this.$store.commit('setBtnLoading', true);

      const formData = this.handleFormData();

      const {errResponse, data: responseData} = await this.$store.dispatch('frontend/auth/register', formData);
      if (!errResponse && responseData.success) {
        // logout user if was login
        const tokenBearer = this.$store.state.frontend.auth.token;
        if(tokenBearer) {
          await this.logout();
        }

        if(this.ssoRegister) {
          await this.$store.dispatch('frontend/auth/getUserInfo');
        } else {
          await this.$notify.success({title: '会員登録が完了しました'});
          await this.$store.commit('setBtnLoading', false);
        }
        this.$store.commit('frontend/auth/setRegisterEmail', '')

        sessionStorage.setItem('emailConfirm', this.formData.email);
        sessionStorage.setItem('authUserID', responseData.data.id);
        clearRegisterLandingUrl(this.$cookies);

        return this.$router.push(`/auth/change-info/${responseData.data.token}`);
      }

      if (responseData.data && Object.keys(responseData.data).length > 0) {
        this.$notify.error({ title: responseData.message });
        this.$refs.observer.setErrors(responseData.data)
        await this.$store.commit('setBtnLoading', false);
        return false;
      }

      return this.$notify.error({title: responseData.message});
    },
    handleFormData() {
      const formData = cloneDeep(this.formData);

      formData.company.business = this.multiselect.businesses.map(item => item.id);
      formData.company.pension_insurance = this.formData.company.pension_insurance.map(item => item.id);
      formData.company.employment_insurance = this.formData.company.employment_insurance.map(item => item.id);
      formData.service = this.isApplicationRegister ? 'app' : '';
      if (this.registerLandingId) {
        formData.register_landing_id = this.registerLandingId;
      }
      if (this.registerApplicationId) {
        formData.register_application_id = this.registerApplicationId;
      }

      return formData;
    }
  }
}
